import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const LoginWrapper = () => {
  const location = useLocation();

  useEffect(() => {
    const isSignup = location.pathname === "/signup";
    const redirectUrl = isSignup
      ? "/login.html?form=signup"
      : "/login.html?form=login";

    window.location.href = redirectUrl;
  }, [location.pathname]);

  return <div>Redirecting...</div>;
};

export default LoginWrapper;
